export {default} from "./Faq";
